import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import momentPropTypes from 'react-moment-proptypes';
import moment from 'moment';

import { VisualOnlyLabel } from '../Label';
import { Inline } from '../LayoutPrimitives';
import { SingleDatePickerWrapper } from './SingleDatePickerWrapper';
import TimePicker from './TimePicker';

export default function DateTimePicker({
    id = 'date-time-picker',
    isRequired,
    isDisabled,
    isInvalid,
    date,
    timezone,
    onChange = () => {},
    ...props
}) {
    const timeValue = date?.format('HH:mm');
    const datePickerRef = useRef();

    const handleDateChange = (newDate) => {
        const [hour, minute] = timeValue.split(':');
        newDate.set({ hour, minute });
        onChange(newDate);
    };

    const handleTimeChange = (newTime) => {
        const [hour, minute] = newTime.split(':');
        const newDate = moment(date);
        newDate.set({ hour, minute });
        onChange(newDate);
    };

    return (
        <div data-component="DateTimePicker" {...props}>
            <Inline space="lg">
                <div>
                    <VisualOnlyLabel isRequired={isRequired} data-date-picker-label>
                        Date
                    </VisualOnlyLabel>
                    <SingleDatePickerWrapper
                        ref={datePickerRef}
                        id={id}
                        disabled={isDisabled}
                        date={date}
                        onDateChange={handleDateChange}
                        isInvalid={isInvalid}
                    />
                </div>
                <TimePicker
                    id={`${id}-time-picker`}
                    isRequired={isRequired}
                    timezone={timezone}
                    value={timeValue}
                    onChange={handleTimeChange}
                    isDisabled={isDisabled}
                    isInvalid={isInvalid}
                />
            </Inline>
        </div>
    );
}

DateTimePicker.propTypes = {
    /** id used for accessibility */
    id: PropTypes.string,

    /** A string used to describe the timezone. This has no impact on the workings of the
     * component, it is presentational only */
    timezone: PropTypes.string,

    /** Marks the field as required; Adds required styling to label */
    isRequired: PropTypes.bool,

    /** Disables the field */
    isDisabled: PropTypes.bool,

    /** Disables the field */
    isInvalid: PropTypes.bool,

    /** Value of the controlled component */
    date: momentPropTypes.momentObj,

    /** Change handler */
    onChange: PropTypes.func,
};

// export class DateTimePickerWithValidation extends React.PureComponent {
//     state = {
//         time: null,
//     };

//     componentDidUpdate(prevProps, prevState) {
//         const { onChange, date } = this.props;
//         const { time } = this.state;

//         if (time !== prevState.time) {
//             const [hour, minute] = time.split(':');
//             const newDate = moment(date);
//             newDate.set({ hour, minute });
//             onChange(newDate);
//         }
//     }

//     handleTimeChange = (time) => {
//         this.setState({ time });
//     };

//     validate = () => {
//         const datePickerValidation = this.datePickerRef.validate();
//         const timePickerValidation = this.timePickerRef.validate();
//         console.log('datePickerValidation', datePickerValidation);
//         console.log('timePickerValidation', timePickerValidation);
//     };

//     render() {
//         const { date, isRequired, id, isDisabled, onChange, ...rest } = this.props;
//         const timeValue = date?.format('HH:mm');

//         return (
//             <div id={id} data-component="DateTimePicker" {...rest}>
//                 <Inline space="lg">
//                     <div>
//                         <VisualOnlyLabel isRequired={isRequired} data-date-picker-label>
//                             Date
//                         </VisualOnlyLabel>
//                         <SingleDatePickerWrapper
//                             ref={(node) => {
//                                 this.datePickerRef = node;
//                             }}
//                             isRequired={isRequired}
//                             id={`${id}-date-picker`}
//                             disabled={isDisabled}
//                             date={date}
//                             onDateChange={onChange}
//                         />
//                     </div>
//                     <TimePicker
//                         ref={(node) => {
//                             this.timePickerRef = node;
//                         }}
//                         isDisabled={isDisabled}
//                         id={`${id}-time-picker`}
//                         isRequired={isRequired}
//                         timezone="US/Eastern Time Zone"
//                         value={timeValue}
//                         onChange={this.handleTimeChange}
//                     />
//                 </Inline>
//             </div>
//         );
//     }
// }
